import React from "react"
import styled from "styled-components"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import { device } from "../../utils/breakpoints"
import AmateursImage from "./AmateursImage"
import { colors } from "../../utils/theme"
import Logos from "../hero/Logos"

const AmateursCol = styled(BackgroundImage)`
  width: 100%;
  height: 100%;
  margin: 0;
  padding-bottom: 3rem;
  & .info-col {
    padding: 3rem 5% 1rem 5%;
    color: white;
    position: relative;
    z-index: 1;
    @media ${device.md} {
      padding: 3rem 15% 1rem 50%;
    }
    & .title {
      padding: 2rem 0 0rem 0;
      text-align: center;
      color: white;
      font-weight: 800;
      text-transform: uppercase;
      margin: 0;
      font-style: italic;
      font-size: 1em;
      @media ${device.md} {
        text-align: left;
      }
      & span {
        padding: 0.4em 1em;
        position: relative;
        z-index: 2;
        font-size: 0.8em;
        &::before {
          content: "";
          width: 100%;
          height: 100%;
          background: ${colors.pColor};
          transform: skew(-7deg);
          position: absolute;
          left: 0;
          top: 0;
          z-index: -1;
        }
        &::after {
          content: "";
          width: 100%;
          height: 100%;
          transform: skew(-10deg);
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
        }
      }
      @media ${device.lg} {
        font-size: 1.2em;
        text-align: left;
      }
    }
    & .cyberpunk {
      font-family: "sketter";
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      font-size: 1.2em;
      position: relative;
      padding-top: 1.8rem;
      margin-bottom: 3rem;
      @media ${device.md} {
        justify-content: flex-start;
      }
      &-first {
        display: block;
        text-align: center;
        color: white;
        z-index: 2;
        position: absolute;
        text-shadow: 0 0 10px rgba(0, 0, 0, 1);
        @media ${device.lg} {
          left: 0;
        }
        &::after {
          content: "";
          top: -10px;
          left: 50%;
          width: 110%;
          height: 2px;
          transform: translateX(-47%);
          background: ${colors.sColor};
          position: absolute;
          border-radius: 6px;
          box-shadow: 0 0 20px ${colors.sColor};
          z-index: 3;
        }
        &::before {
          content: "";
          bottom: -10px;
          left: 50%;
          width: 110%;
          height: 2px;
          transform: translateX(-47%);
          background: ${colors.sColor};
          position: absolute;
          border-radius: 6px;
          box-shadow: 0 0 20px ${colors.sColor};
          z-index: 3;
        }
      }
      &-second {
        display: block;
        text-align: center;
        z-index: 1;
        color: ${colors.pColor};
        position: absolute;
        text-shadow: 0 0 20px ${colors.sColor};
        transform: translate(2px, 5px);
        @media ${device.lg} {
          left: 0;
        }
      }
      @media ${device.lg} {
        font-size: 1.2em;
        text-align: left;
        padding-left: 50%;
      }
    }
    & h3 {
      font-weight: 800;
      font-style: italic;
      color: ${colors.sColor};
      font-size: 0.9em;
      text-align: center;
      @media ${device.md} {
        text-align: left;
      }
    }
    & p {
      font-size: 0.8em;
      text-align: center;
      @media ${device.md} {
        text-align: left;
      }
    }
  }
`

function Amateurs() {
  const { background } = useStaticQuery(graphql`
    query {
      background: file(relativePath: { eq: "back-amateurs.jpg" }) {
        sharp: childImageSharp {
          fluid(quality: 80, maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  console.log(background)
  return (
    <AmateursCol tag="div" fluid={background.sharp.fluid} fadeIn="soft">
      <AmateursImage />
      <div className="info-col">
        <h1 className="title">
          <span>Categoría</span>
        </h1>
        <h2 className="cyberpunk">
          <span className="cyberpunk-first">Principiantes</span>
          <span className="cyberpunk-second">Principiantes</span>
        </h2>
        <div className="puesto">
          <h3>
            {" "}
            1<sup>ER</sup> Puesto
          </h3>
          <p>
            <strong>BECA DEL 100%</strong> en nuestro máster de personajes para
            videojuegos AAA (Acceso un año a contenido que complemente tu curva
            de aprendizaje)
          </p>
        </div>

        <div className="puesto">
          <h3>
            {" "}
            2<sup>DO</sup> Puesto
          </h3>
          <p>Soldado AAA</p>
        </div>
        <div className="puesto">
          <h3>
            {" "}
            3<sup>ER</sup> Puesto
          </h3>
          <p>Personaje estilizado para videojuegos</p>
        </div>
        <div className="puesto">
          <h3>
            {" "}
            4<sup>TO</sup> Puesto
          </h3>
          <p>Licencias vitalicias en : </p>
          <Logos align={'left'}/>
        </div>
      </div>
    </AmateursCol>
  )
}

export default Amateurs
